import React from 'react'
import { Card, Spinner, Badge, Row, Col } from 'react-bootstrap'
import { getSignalBars } from './NetworkRow'

const NetworkStatusCard = ({ statusLoading, networkStatus }) => {
    const eth = networkStatus?.ethernet
    const wifi = networkStatus?.wifi

    return (
        <Card className='mb-5'>
            <Card.Header className='border-0 pt-5'>
                <Card.Title className='align-items-start flex-column'>
                    <span className='fw-bold fs-3'>Network Status</span>
                    <span className='text-muted mt-1 fw-semibold fs-7'>Current connection status</span>
                </Card.Title>
            </Card.Header>
            <Card.Body className='pt-0'>
                {statusLoading ? (
                    <div className='text-center py-5'><Spinner animation='border' variant='primary' /></div>
                ) : (
                    <Row>
                        <Col md={6} className='mb-4'>
                            <div className='d-flex align-items-center mb-3'>
                                <i className='bi bi-ethernet fs-2 me-3 text-primary' />
                                <div>
                                    <div className='fw-bold fs-6'>Ethernet</div>
                                    <Badge bg={eth?.connected ? 'success' : 'secondary'} className='mt-1'>
                                        {eth?.connected ? 'CONNECTED' : 'DISCONNECTED'}
                                    </Badge>
                                </div>
                            </div>
                            {eth?.connected && (
                                <div className='ms-10 text-muted fs-7'>
                                    <div>IP: {eth.ip}</div>
                                    <div>Gateway: {eth.gateway}</div>
                                </div>
                            )}
                        </Col>
                        <Col md={6} className='mb-4'>
                            <div className='d-flex align-items-center mb-3'>
                                <i className='bi bi-wifi fs-2 me-3 text-primary' />
                                <div>
                                    <div className='fw-bold fs-6'>WiFi</div>
                                    <Badge bg={wifi?.connected ? 'success' : 'secondary'} className='mt-1'>
                                        {wifi?.connected ? 'CONNECTED' : 'DISCONNECTED'}
                                    </Badge>
                                </div>
                            </div>
                            {wifi?.connected && (
                                <div className='ms-10 text-muted fs-7'>
                                    <div>SSID: {wifi.ssid}</div>
                                    <div>IP: {wifi.ip}</div>
                                    <div className='d-flex align-items-center gap-2'>
                                        Signal: {wifi.signal}% {getSignalBars(wifi.signal)}
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    )
}

export { NetworkStatusCard }
